import React, { Fragment, useState } from 'react'
import { string, shape, func } from 'prop-types'

import Link from 'src/common/components/link'
import classNames from 'src/common/helpers/class-names'

import { Volume, LinkSavePrimaryBanner } from 'shared/interim/product'
import { isRetinaDisplay } from 'shared/util'

import Favourites from './favourites'
import notAvailableImage from './no-image-available.gif'

import { BLOCK as blk } from './constants'

const ImageStickerVolume = (props) => {
  const {
    images,
    name,
    handleFavouriteClick,
    className,
    weight,
    size,
    assetType,
    promoDetails,
    productDetails,
    handleProductClick,
    itemUrl,
  } = props

  const [state, setState] = useState({
    altText: '',
    isLoading: true,
  })

  const imgClass = classNames({
    className,
    blk,
    elt: 'image',
    mods: [
      state.isLoading && 'load-effect',
    ],
  })

  const setAlt = () => {
    setState({
      altText: name || 'Not Available',
      isLoading: false,
    })
  }

  const getScene7ImageUrl = () => {
    const { scene7Host, scene7Id: assetId } = images
    const host = scene7Host

    if (!host || !assetId) return ''
    let updatedAssetType = assetType
    if (!assetType && size === 'default') {
      updatedAssetType = isRetinaDisplay() ? '?$ProdList2x$' : '?$ProdList$'
    }

    return `${host}asdagroceries/${assetId}${updatedAssetType}`
  }

  const setNoAvailableImage = (e) => {
    e.target.src = notAvailableImage
    setAlt()
  }

  return (
    <Fragment>
      <Link
        asAnchor
        href={itemUrl}
        target='_blank'
        rel='noopener noreferrer'
        dataAutoId='linkProductImage'
        clickHandler={handleProductClick}
      >
        <img
          className={imgClass}
          alt={state.altText}
          onLoad={setAlt}
          importance='high'
          src={getScene7ImageUrl()}
          onError={setNoAvailableImage}
        />
      </Link>
      <div className={classNames({ blk, elt: 'items-container' })}>
        <Favourites
          productDetails={productDetails}
          handleFavouriteClick={handleFavouriteClick}
        />
        <div
          className={classNames({
            blk,
            elt: 'volume-container',
            className: 'co-item__items',
          })}
        >
          <Volume value={weight} />
        </div>
      </div>
      {promoDetails.promoId ? (
        <LinkSavePrimaryBanner
          url={itemUrl}
          responsive
          clickHandler={handleProductClick}
          {...promoDetails}
        />
      ) : null}
    </Fragment>
  )
}

ImageStickerVolume.propTypes = {
  images: shape({ default: string }).isRequired,
  name: string.isRequired,
  weight: string.isRequired,
  promoDetails: shape({ promoId: string }).isRequired,
  className: string,
  productDetails: shape({
    id: string,
  }),
  size: string,
  assetType: string,
  handleFavouriteClick: func,
  handleProductClick: func,
  itemUrl: string.isRequired,
}

ImageStickerVolume.defaultProps = {
  productDetails: {},
  size: 'default',
  className: '',
  assetType: '',
  handleFavouriteClick() {},
  handleProductClick() {},
}

export default ImageStickerVolume



// WEBPACK FOOTER //
// ./shared/interim/product-list/item/image-sticker-volume.js